import { useState } from 'react';
import { useDispatch } from 'react-redux';
import { toast } from 'react-toastify';
import ToastMessages from '../../components/ToastMessages/toastMessages';
import { api } from '../../services/api';
import { populateAvailableCarts } from '../../store/ducks/tables/actions';

export interface GetCarts {
  page: number;
  rows: Row[];
  totalRecords: number;
}

export interface Row {
  cartId: string;
  distance: number;
  corporateName: string;
  address: string;
  totalWeight: number;
  createdAt: Date;
  updatedAt?: Date;
}

export default function useNearGetCarts() {
  const [loading, setLoading] = useState(false);
  const dispatch = useDispatch();

  async function execute(params: {
    page: number;
    rowsPerPage?: number;
    freightRequestId?: string;
  }) {
    try {
      setLoading(true);
      const response = await api.get('v1/backoffice/carts:near', {
        params: {
          rowsPerPage: params.rowsPerPage || 20,
          page: params.page,
          freightRequestId: params.freightRequestId,
        },
      });

      if (response.status === 200) {
        dispatch(populateAvailableCarts(response.data));
        return response.data;
      }
    } catch (error) {
      if (!Array.isArray((error as any).response.data.message)) {
        toast.error(ToastMessages.general.error.operationFailed);
      } else {
        (error as any).response.data.message.map((err: any) =>
          toast.error(ToastMessages.general.error.genericError),
        );
      }
    } finally {
      setLoading(false);
    }
  }

  return { execute, loading };
}
